import {useMain} from '@/hooks/useMain'
import {useCurrentUser} from '@/hooks/useCurrentUser'
import {useIntl} from 'react-intl'

export const Home = () => {
  const {formatMessage} = useIntl()
  const {firstName} = useCurrentUser()

  useMain()

  return (
    <div className="flex flex-col">
      <p className="mb-4 text-3xl font-bold" data-cy="welcome-message">
        {formatMessage(
          {id: 'NBA_LIST.WELCOME_MESSAGE'},
          {
            userName: firstName || 'User',
          }
        )}
      </p>
    </div>
  )
}
